<template>
  <img alt="award icon" height="40" src="/assets/AwardIcon.webp" loading="lazy" width="45">
</template>
